import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import {
	Dropdown,
	DropdownItem,
	DropdownMenu,
	DropdownToggle,
} from "reactstrap"

import { getActiveTheme, getThemePreference, onThemeChange, setThemePreference } from "helpers/theme"

const options = [
	{ value: 'light', icon: 'uil-sun', label: 'color_theme_light' },
	{ value: 'dark', icon: 'uil-moon', label: 'color_theme_dark' },
	{ value: 'system', icon: 'uil-desktop', label: 'color_theme_system' },
]

function ThemeDropdown() {
	const { t } = useTranslation()

	const [menu, setMenu] = useState(false)
	const [preference, setPreference] = useState(getThemePreference())
	const [activeTheme, setActiveTheme] = useState(getActiveTheme())

	function selectTheme(value) {
		setThemePreference(value)
		setPreference(value)
	}

	useEffect(() => {
		return onThemeChange((theme) => {
			setActiveTheme(theme)
			setPreference(getThemePreference())
		})
	}, [])

	return (
		<Dropdown isOpen={menu} toggle={() => setMenu(!menu)} className="d-inline-block">
			<DropdownToggle className="btn header-item waves-effect" tag="button" title={t('color_theme')}>
				<i className={'uil fz-20 ' + (activeTheme === 'dark' ? 'uil-moon' : 'uil-sun')}></i>
			</DropdownToggle>
			<DropdownMenu className="dropdown-menu-end" right>
				{options.map(item => (
					<DropdownItem
						key={item.value}
						onClick={() => selectTheme(item.value)}
						className={'notify-item ' + (preference === item.value ? 'active' : '')}>
						<i className={'uil ' + item.icon + ' me-2'}></i>
						<span className="align-middle">{t(item.label)}</span>
					</DropdownItem>
				))}
			</DropdownMenu>
		</Dropdown>
	)
}

export default ThemeDropdown
